module.exports = "/images/vendor/flag-icon-css/flags/4x3/cf.svg?2171101e459db58cc9311ec6a0926648";